import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { IAppConfig } from '../interface/app-config.interface';

@Injectable()
export class AppConfig {
  private static _settings: IAppConfig;
  public static get settings(): IAppConfig {
    return AppConfig._settings;
  }

  // Config is sourced from the build-time environment (swapped per env via angular.json).
  load(): Promise<void> {
    const cal = environment.calConfig;
    AppConfig._settings = {
      production: environment.production,
      clientId: cal.clientId,
      tenantId: cal.tenantId,
      redirectUri: cal.redirectUri,
      baseUrl: environment.webUrl,
      apiUrl: environment.apiEndpoint,
      oidcScopes: cal.oidcScopes,
      graphScopes: cal.graphScopes,
      apiScopes: environment.apiScopes,
      fluidLayout: environment.fluidLayout,
    };
    return Promise.resolve();
  }
}
